'use strict';

module.exports = '3.29.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 484
// module chunks = 142807904292071